import front from "./exam_dog_front.svg";
import back from "./exam_dog_back.svg";

const dog = {
  front,
  back,
};

export default dog;
